import { render, staticRenderFns } from "./VideoHeadText.vue?vue&type=template&id=79a08f28&scoped=true&"
import script from "./VideoHeadText.vue?vue&type=script&lang=js&"
export * from "./VideoHeadText.vue?vue&type=script&lang=js&"
import style0 from "./VideoHeadText.vue?vue&type=style&index=0&id=79a08f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a08f28",
  null
  
)

export default component.exports